import { render } from "./CIS-ResourcePublishedDate.vue?vue&type=template&id=71ea65d6"
import script from "./CIS-ResourcePublishedDate.vue?vue&type=script&lang=js"
export * from "./CIS-ResourcePublishedDate.vue?vue&type=script&lang=js"

import "./CIS-ResourcePublishedDate.vue?vue&type=style&index=0&id=71ea65d6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__